import { useI18n } from '#/i18n/hooks/useI18n';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { OAuthButton } from './OAuthButton';

type Props = {
  getUrl: () => string | Promise<string>;
};

export function AppleOAuthButton({ getUrl }: Props) {
  const { i18n } = useI18n();

  return (
    <OAuthButton
      imgSrc={getStaticImageSrc('icons/social/apple.svg')}
      imgAlt="Apple"
      text={i18n('Continue with Apple')}
      getUrl={getUrl}
      qaId="apple-oauth"
    />
  );
}
